// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__2n4vw","icon":"IconButton_icon__1VpE5","loader":"IconButton_loader__1PVxK","filled":"IconButton_filled__1JXBz"};